import axios from 'axios'
import { useEffect, useState } from 'react'
import styles from './zone.module.css'
import { useLocation, useNavigate } from 'react-router-dom'

const Zone = () => {

    const [zones, setZones] = useState([])
    const fetch = async () => {
        try {
            const result = await axios.get(`${process.env.REACT_APP_URL}/api/outstation/fetchzones`,
                { withCredentials: true }
            )
            setZones(result.data.zones)
            console.log(result.data.zones[0].coordinates, "here in zone")
        } catch (error) {
            console.log(error, "error in fetching zones")
        }
    }

    useEffect(() => {
        fetch()
    }, [])
    const navigate = useNavigate()
    const handleNavigate = (name, coordinates) => {
        console.log(name, coordinates, "name and coordinates")
        navigate('map', { state: { zoneName: name, coordinates: coordinates } })
    }
    return (
        <div className={styles.contain}>
            <div className={styles.heading}>
                <h2 className={styles.head}>
                    Zones
                </h2>
                <button
                    className={styles.add}
                    type='button'
                    onClick={() => navigate('map', { state: { zoneName: '' } })}
                >Add new Zone
                </button>
            </div>
            <div
                className={styles.cardsContainer}
            >
                {zones.length > 0 && zones.map((zone, index) => (
                    <div key={index}
                        className={styles.card}>
                        <span className={styles.head}>{zone.name}</span>
                        <div className={styles.actions}>
                            <button onClick={() => handleNavigate(zone.name, zone.coordinates)}>view</button>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    )
}

export default Zone